// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { fluenceTestnet as _fluenceTestnet } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the fluenceTestnet chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 52164803
 * Chain Name: Fluence Testnet
 * Default Block Explorer: https://blockscout.testnet.fluence.dev
 * Default RPC URL: https://rpc.testnet.fluence.dev
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { fluenceTestnet } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: fluenceTestnet,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const fluenceTestnet = createCommon({
	..._fluenceTestnet,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
